<template>
	<div class="swiper">
		<div class="menu-wrap">
			<el-carousel class="swiper-box" height="400px" indicator-position="outside">
				<el-carousel-item v-for="(item,index) in bannerList" :key="index">
					<img class="banner" :src="item.banner" :alt="item.alt">
				</el-carousel-item>
			</el-carousel>
			<div class="nav-box">
				<nav class="m-menu" @mouseleave="mouseleave">
					<dl>
						<dd 
							:class="index==current?'active':''"
							v-for="(item,index) in menu" 
							:key="index" 
							@mouseover="mouseover(index)">
							<div class="left">
								<img class="meu-befor-icon" :src="item.icon" :alt="item.title">
								<span>{{item.title}}</span>
							</div>
							<div class="right">
								<img src="../assets/images/icon_arrow_right.png" alt="arrow">
							</div>
						</dd>
					</dl>
					<div class="menu-detail-wrap">
						<div class="menu-detail" v-if="current<=menu.length">
							<ul class="second-menu">
								<li 
									v-for="(item,index) in menu[current].brandList" 
									:key="index"
									:class="index==brandCurrent?'brand-active':''" 
									@mouseover="brandover(index)">
									{{item.brand}}
								</li>
								<li @click="showMask">更多</li>
							</ul>
							<div class="goods-menu">
								<div class="goods-item" v-for="(item,index) in menu[current].brandList[brandCurrent].list">
									<div class="left">
										<img :src="item.img" :alt="item.model">
										<span>{{item.model}}</span>
									</div>
									<div class="right" @click="showMask">估价</div>
								</div>
								<div class="goods-item" v-if="menu[current].brandList[brandCurrent].list.length >= 5">
									<div class="more" @click="showMask">更多 ></div>
								</div>
							</div>
						</div>
					</div>
				</nav>
			</div>
		</div>
		
		<!-- 服务流程 -->
		<div class="m-process-box">
			<div class="process-box-title">
				<div>服务流程</div>
				<div class="border"></div>
			</div>
			<div class="process-list-box">
				<ul class="process-list">
					<li class="process-item" v-for="(item,index) in processList" :key="index">
						<div>
							<img class="process-icon" :src="item.image" alt="派派回收">
							<div class="process-title">{{item.title}}</div>
						</div>
						<div class="item-line" v-if="index<processList.length-1">
							<img src="../assets/images/icon_bg_png.png" alt="派派回收" class="line">
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default{
	data(){
		return {
			current: 99,
			brandCurrent: 0,
			bannerList: [
				{title: '', banner: require('../assets/images/banner1.png'), alt: '高价回收'},
				{title: '', banner: require('../assets/images/banner2.png'), alt: '回收专家'},
				{title: '', banner: require('../assets/images/banner3.png'), alt: '顺丰包邮'},
				{title: '', banner: require('../assets/images/banner4.png'), alt: '立即下载'}
			],
			menu: [
				{
					title: '手机',
					icon: require('../assets/images/icon_phone.png'),
					brandList: [
						{
							brand: '苹果',
							list: [
								{model: '苹果 iPhone X 白色|大陆国行|A1865（全网通）|256GB',price:'2710.00',img:require('../assets/images/goods/apple/iPhoneX.png')},
								{model: '苹果 iPhone 7 大陆国行|黑色|A1660（全网通）|256GB',price:'1050.00',img:require('../assets/images/goods/apple/iPhone7.png')},
								{model: '苹果 iPhone 7 Plus 大陆国行|金色|A1661（全网通）|256GB',price:'1600.00',img:require('../assets/images/goods/apple/iPhone7Plus.png')},
								{model: '苹果 iPhone 6 Plus 大陆国行|黑色|A1524（全网通）|128GB',price:'680.00',img:require('../assets/images/goods/apple/iPhone6Plus.png')},
								{model: '苹果 iPhone 6 大陆国行|黑色|其他型号|128GB',price:'580.00',img:require('../assets/images/goods/apple/iPhone6.png')}
							]
						},
						{
							brand: '华为',
							list: [
								{model: '华为 P40 Pro（5G版） 全网通|大陆国行|8G+512G',price:'4909.00',img:require('../assets/images/goods/huawei/huaweiP40Pro.png')},
								{model: '华为 Mate 30 Pro（5G版） 大陆国行|8G+512G',price:'4263.00',img:require('../assets/images/goods/huawei/huaweiMate30Pro.png')},
								{model: '华为 nova 7（5G版） 8G+256G|全网通|大陆国行',price:'2067.00',img:require('../assets/images/goods/huawei/huaweiNova7.png')},
								{model: '华为 Mate 20 Pro（UD）屏幕指纹版 大陆国行|全网通|8G+256G',price:'1938.00',img:require('../assets/images/goods/huawei/huaweiMate20Pro.png')},
								{model: '华为 P30 全网通|大陆国行|8G+256G',price:'1959.00',img:require('../assets/images/goods/huawei/huaweiP30.png')}
							]
						},
						{
							brand: '小米',
							list: [
								{model: '小米手机 10 Pro（5G版） 白色|12G+512G',price:'3666.00',img:require('../assets/images/goods/xiaomi/mi10Pro.png')},
								{model: '小米手机 9 Pro（5G版） 大陆国行|白色|12G+512G',price:'2141.00',img:require('../assets/images/goods/xiaomi/mi9Pro.png')},
								{model: '小米手机 9 大陆国行|全网通|12G+256G|透明',price:'1538.00',img:require('../assets/images/goods/xiaomi/mi9.png')},
								{model: 'Redmi K30 Pro 变焦版（5G版） 蓝色|12G+512G',price:'2347.00',img:require('../assets/images/goods/xiaomi/redmiK30Pro.png')},
								{model: '小米手机 10（5G版） 蓝色|12G+256G',price:'2746.00',img:require('../assets/images/goods/xiaomi/mi10.png')}
							]
						},
						{
							brand: 'vivo',
							list: [
								{model: 'vivo NEX 3S（5G版） 液态天河|大陆国行|12G+256G',price:'2989.00',img:require('../assets/images/goods/vivo/vivoNex13S_5G.png')},
								{model: 'vivo S7（5G） 8G+256G',price:'1600.00',img:require('../assets/images/goods/vivo/vivoS7_5G.png')},
								{model: 'vivo V17 Pro',price:'948.00',img:require('../assets/images/goods/vivo/vivoV17.png')},
								{model: 'vivo X50 Pro（5G版） 8G+256G',price:'2753.00',img:require('../assets/images/goods/vivo/vivoX50Pro.png')},
								{model: 'vivo Y70s（5G版） 8G+128G',price:'1200.00',img:require('../assets/images/goods/vivo/vivoY70S.png')}
							]
						},
						{
							brand: 'OPPO',
							list: [
								{model: 'OPPO Reno4（5G版） 8G+256G',price:'1871.00',img:require('../assets/images/goods/oppo/oppoReno4_5G.png')},
								{model: 'OPPO Reno3 Pro（5G版） 大陆国行|红蓝|12G+256G',price:'2058.00',img:require('../assets/images/goods/oppo/oppoReno3Pro_5G.png')},
								{model: 'OPPO Reno2 大陆国行|8G+128G',price:'1175.00',img:require('../assets/images/goods/oppo/oppoReno2.png')},
								{model: 'OPPO R17 Pro 大陆国行|8G+128G|其他限量版',price:'1019.00',img:require('../assets/images/goods/oppo/oppoR17Pro.png')},
								{model: 'OPPO K5 绿色|8G+256G',price:'1170.00',img:require('../assets/images/goods/oppo/oppoK5.png')}
							]
						},
						{
							brand: '荣耀',
							list: [
								{model: '荣耀 20 Pro 大陆国行|8G+256G',price:'1342.00',img:require('../assets/images/goods/honor/honor20Pro.png')},
								{model: '荣耀 30 Pro+（5G版） 12G+256G|大陆国行',price:'3606.00',img:require('../assets/images/goods/honor/honor30Pro_5G.png')},
								{model: '荣耀 Magic2 全网通|大陆国行|8G+256G',price:'1233.00',img:require('../assets/images/goods/honor/honorMagic2.png')},
								{model: '荣耀 Play4 Pro（5G版）',price:'1100.00',img:require('../assets/images/goods/honor/honorPlay4Pro.png')},
								{model: '荣耀 V30（5G版） 大陆国行|8G+128G',price:'1764.00',img:require('../assets/images/goods/honor/honorV30.png')}
							]
						},
					]
				},
				{
					title: '平板',
					icon: require('../assets/images/icon_ipad.png'),
					brandList: [
						{
							brand: '苹果',
							list: [
								{model: 'iPad Pro 11寸 2代 2020款 WIFI+4G|1TB',price:'8800.00',img:require('../assets/images/goods/apple/iPadPro2020.png')},
								{model: 'iPad Pro 12.9寸 4代 2020款 WIFI+4G|1TB',price:'7740.00',img:require('../assets/images/goods/apple/iPadPro2020_12.7.png')},
								{model: 'iPad Air2 128GB',price:'1220.00',img:require('../assets/images/goods/apple/iPadAir2.png')},
								{model: 'iPad Pro 12.9寸 2代 2017款 WIFI+4G|512GB',price:'3350.00',img:require('../assets/images/goods/apple/iPadPro2017.png')},
								{model: 'iPad Air3 WIFI+4G|256GB',price:'3060.00',img:require('../assets/images/goods/apple/iPadMini2.png')}
							]
						},
						{
							brand: '华为',
							list: [
								{model: '华为 MatePad Pro 橙色|8G+512G|WIFI+5G',price:'4035.00',img:require('../assets/images/goods/huawei/huaweiMatePadPro.png')},
								{model: '华为 MatePad 6G+128G|WIFI+4G',price:'1280.00',img:require('../assets/images/goods/huawei/huaweiMatePad_128.png')},
								{model: '华为平板 M6 8.4英寸 高能版 WIFI+4G',price:'1580.00',img:require('../assets/images/goods/huawei/huaweiPadM6.png')},
								{model: '华为平板 M5 Pro WIFI+4G',price:'910.00',img:require('../assets/images/goods/huawei/huaweiPadM5.png')},
								{model: '华为平板 M3 128G|WIFI+4G',price:'610.00',img:require('../assets/images/goods/huawei/huaweiMatePadM3.png')}
							]
						},
						{
							brand: '小米',
							list: [
								{model: '小米平板4 Plus 128G',price:'1320.00',img:require('../assets/images/goods/xiaomi/miPad4Plus.png')},
								{model: '小米平板4 64G|WIFI+4G',price:'760.00',img:require('../assets/images/goods/xiaomi/miPad4.png')},
								{model: '小米平板 3 不分版本',price:'437.00',img:require('../assets/images/goods/xiaomi/miPad3.png')},
								{model: '小米平板2 64G',price:'287.00',img:require('../assets/images/goods/xiaomi/miPad2.jpg')},
								{model: '小米平板 64G',price:'237.00',img:require('../assets/images/goods/xiaomi/miPad1.png')}
							]
						},
						{
							brand: '联想',
							list: [
								{model: '联想Yoga Tab3 Plus 不分版本',price:'312.00',img:require('../assets/images/goods/lenovo/lenovoYOGATab3Plus.png')},
								{model: '联想YOGA Tab 5（YT-X705） 大陆国行',price:'805.00',img:require('../assets/images/goods/lenovo/lenovoYOGATab5.png')},
								{model: '联想YOGA Tab 3 Pro 不分版本',price:'505.00',img:require('../assets/images/goods/lenovo/lenovoYOGATab3.png')},
								{model: '联想 Tab M8 WIFI+4G',price:'372.00',img:require('../assets/images/goods/lenovo/lenovoTabM8.png')},
								{model: '联想 小新平板 10.1英寸(TB-X804F) 不分版本',price:'362.00',img:require('../assets/images/goods/lenovo/lenovoTab8.png')}
							]
						},
						{
							brand: '荣耀',
							list: [
								{model: '荣耀X2 128G|WIFI',price:'417.00',img:require('../assets/images/goods/honor/honorPadX2_128.png')},
								{model: '荣耀平板5 10.1英寸 64G|WIFI+4G',price:'610.00',img:require('../assets/images/goods/honor/honorPad2.png')},
								{model: '荣耀畅玩平板2 9.6英寸 WIFI+4G|32G',price:'347.00',img:require('../assets/images/goods/honor/honorPadPlay.png')},
								{model: '荣耀Waterplay防水影音平板 10.1英寸 64G|WIFI',price:'510.00',img:require('../assets/images/goods/honor/honorPadWater.png')},
								{model: '荣耀平板5 8英寸 WIFI|128G',price:'510.00',img:require('../assets/images/goods/honor/honorPad5.png')}
							]
						},
						{
							brand: '三星',
							list: [
								{model: '三星Galaxy Tab S6 WIFI+4G|8G+256G',price:'3385.00',img:require('../assets/images/goods/samsung/GalaxyTabS6.png')},
								{model: '三星Galaxy Tab S5e 128G|WIFI+4G',price:'1760.00',img:require('../assets/images/goods/samsung/GalaxyTabS5e.png')},
								{model: '三星Galaxy Tab S4(T830/T835/T837) 256G|WIFI+4G',price:'1960.00',img:require('../assets/images/goods/samsung/GalaxyTabS4.png')},
								{model: '三星Galaxy Tab S3(T820/T825/T827) WIFI+4G',price:'1020.00',img:require('../assets/images/goods/samsung/GalaxyTabS3.png')},
								{model: '三星Galaxy Tab A 10.5(T590/T595) WIFI+4G',price:'710.00',img:require('../assets/images/goods/samsung/GalaxyTabA.png')}
							]
						}
					]
				},
				{
					title: '笔记本',
					icon: require('../assets/images/icon_computer.png'),
					brandList: [
						{
							brand: '苹果',
							list: [
								{model: '苹果 15年 15寸 MacBook Pro 2.8GHz Intel Core i7|AMD M370X+Intel Iris Pro',price:'5550.00',img:require('../assets/images/goods/apple/MacBookPro15_2.png')},
								{model: '苹果 16年 15寸 MacBook Pro 2.9GHz Intel Core i7|Radeon Pro 460+Intel HD',price:'7590.00',img:require('../assets/images/goods/apple/MacBookPro15.png')},
								{model: '苹果 16年 13寸 MacBook Pro 3.3GHz Intel Core i7|16GB|Intel Iris Graphics 550',price:'6550.00',img:require('../assets/images/goods/apple/MacBookPro13.png')},
								{model: '苹果 18年 13寸 MacBook Pro 2.7GHz Intel Core i7|16GB|大陆国行',price:'8550.00',img:require('../assets/images/goods/apple/MacBookPro.png')},
								{model: '苹果 12年 13寸 MacBook Air 2GHz Intel Core i7|8GB',price:'2220.00',img:require('../assets/images/goods/apple/MacBookAir.png')}
							]
						},
						{
							brand: '华为',
							list: [
								{model: '华为 MateBook 13 2020款 2G独立显卡|16GB|Intel 酷睿 i7 10代',price:'4260.00',img:require('../assets/images/goods/huawei/huaweiMateBook13.png')},
								{model: '华为 MateBook 14 2020款 16GB|3G独立显卡|Intel 酷睿 i7 10代',price:'4820.00',img:require('../assets/images/goods/huawei/huaweiMateBook14.png')},
								{model: '华为 MateBook D 15寸 系列 32GB及以上|2G独立显卡|Intel 酷睿 i7 10代',price:'3820.00',img:require('../assets/images/goods/huawei/huaweiMateBookD.png')},
								{model: '华为 MateBook E 系列 高通骁龙 850|8GB',price:'2320.00',img:require('../assets/images/goods/huawei/huaweiMateBookE.png')},
								{model: '华为 MateBook X Pro 2020款 2G独立显卡|Intel 酷睿 i7 10代',price:'7250.00',img:require('../assets/images/goods/huawei/huaweiMateBookX.png')}
							]
						},
						{
							brand: '小米',
							list: [
								{model: '小米 RedmiBook 13 系列 2G独立显卡|Intel 酷睿 i7 10代',price:'2420.00',img:require('../assets/images/goods/xiaomi/redmiBook13.png')},
								{model: '小米笔记本Air 13.3寸 Intel 酷睿 i5 8代|2G独立显卡|8GB',price:'2100.00',img:require('../assets/images/goods/xiaomi/miBookAir.png')},
								{model: '小米 RedmiBook 14 系列 2G独立显卡|16GB-18GB|Intel 酷睿 i7 10代',price:'3120.00',img:require('../assets/images/goods/xiaomi/redmiBook14.png')},
								{model: '小米笔记本 15.6寸 Intel 酷睿 i7 8代|16GB-18GB|2G独立显卡',price:'2120.00',img:require('../assets/images/goods/xiaomi/miBookInter.png')},
								{model: '小米笔记本Pro 15.6寸 Intel 酷睿 i7 10代|16GB-18GB|2G独立显卡',price:'3920.00',img:require('../assets/images/goods/xiaomi/miBookPro.png')}
							]
						},
						{
							brand: '联想',
							list: [
								{model: '联想 Thinkpad L390 系列 32GB及以上|Intel 酷睿 i7 8代',price:'5450.00',img:require('../assets/images/goods/lenovo/Thinkpad_L390.png')},
								{model: '联想ThinkPad P51 系列 Intel 酷睿 i7 7代|32GB及以上|4G独立显卡',price:'5450.00',img:require('../assets/images/goods/lenovo/ThinkPad_P51.png')},
								{model: '联想 Yoga S940 16GB-18GB|Intel 酷睿 i7 10代',price:'5650.00',img:require('../assets/images/goods/lenovo/Yoga_S940.png')},
								{model: '联想ThinkPad X1 Tablet Evo(3rd Gen) 系列 Intel 酷睿 i7 8代|16GB-18GB',price:'5050.00',img:require('../assets/images/goods/lenovo/ThinkPad_X1.png')},
								{model: '联想 ThinkPad X1 Carbon 2019 Intel 酷睿 i7 10代|16GB-18GB|6G独立显卡',price:'8850.00',img:require('../assets/images/goods/lenovo/ThinkPad_X1_Carbon.png')}
							]
						},
						{
							brand: '戴尔',
							list: [
								{model: '戴尔 Inspiron灵越 15 7567(游匣7000) 系列 Intel 酷睿 i7 7代|32GB及以上|4G独立显卡',price:'3438.00',img:require('../assets/images/goods/dell/Inspiron_15_7567.png')},
								{model: '戴尔 Inspiron灵越 14 7460(燃7000) 系列 Intel 酷睿 i5 8代|16GB-18GB|4G独立显卡',price:'2763.00',img:require('../assets/images/goods/dell/Inspiron_14_7460.png')},
								{model: '戴尔 Inspiron灵越 15 5557 系列 Intel 酷睿 i7 6代|16GB-18GB|4G独立显卡',price:'2448.00',img:require('../assets/images/goods/dell/Inspiron_15_5557.png')},
								{model: '戴尔 XPS 13 9350 系列(非触控版) Intel 酷睿 i7 6代|16GB-18GB',price:'2448.00',img:require('../assets/images/goods/dell/XPS_13_9350.png')},
								{model: '戴尔 Inspiron灵越 15 7560(燃7000) 系列 Intel 酷睿 i7 7代|16GB-18GB|4G独立显卡',price:'2358.00',img:require('../assets/images/goods/dell/Inspiron_15_7560.png')}
							]
						},
						{
							brand: '宏碁',
							list: [
								{model: 'Acer 暗影骑士3 VX5-591G 系列 Intel 酷睿 i7 7代|16GB-18GB|4G独立显卡',price:'2520.00',img:require('../assets/images/goods/acer/Acer_VN7_591G.png')},
								{model: 'Acer 暗影骑士2 VN7-592G 系列 Intel 酷睿 i7 6代|16GB-18GB|4G独立显卡',price:'2020.00',img:require('../assets/images/goods/acer/Acer_VN7_592G.png')},
								{model: 'Acer TMP278 系列 Intel 酷睿 i7 6代|8GB|4G独立显卡',price:'1450.00',img:require('../assets/images/goods/acer/Acer_TMP278.png')},
								{model: 'Acer 暗影骑士 VN7-591G 系列 Intel 酷睿 i7 4代|16GB-18GB|4G独立显卡',price:'1910.00',img:require('../assets/images/goods/acer/Acer_VN7_591G.png')},
								{model: 'Acer 掠夺者G9-791 系列 32GB及以上',price:'1950.00',img:require('../assets/images/goods/acer/Acer_G9_791.png')}
							]
						}
					]
				},
				{
					title: '手表',
					icon: require('../assets/images/icon_watch.png'),
					brandList: [
						{
							brand: '苹果',
							list: [
								{model: 'Apple Watch Nike(Series 5)',price:'2875.00',img:require('../assets/images/goods/apple/iwatch_Nike5.jpg')},
								{model: 'Apple Watch Series 5',price:'3099.00',img:require('../assets/images/goods/apple/iwatch_Series5.jpg')},
								{model: 'Apple Watch Series 3',price:'2099.00',img:require('../assets/images/goods/apple/iwatch_Series5.jpg')},
								{model: 'Apple Watch Nike(Series 3)',price:'966.00',img:require('../assets/images/goods/apple/iwatch_Nike3.jpg')},
								{model: 'Apple Watch Nike(Series 4)',price:'2220.00',img:require('../assets/images/goods/apple/iwatch_Nike4.jpg')}
							]
						},
						{
							brand: '华为',
							list: [
								{model: '华为 WATCH GT2(46mm)砂砾棕',price:'879.00',img:require('../assets/images/goods/huawei/WATCH_GT2e.png')},
								{model: '华为 WATCH GT2曜石黑男款',price:'694.00',img:require('../assets/images/goods/huawei/WATCH_GT2.jpg')},
								{model: '华为 WATCH GT2时尚女款',price:'1154.00',img:require('../assets/images/goods/huawei/WATCH_GT2_Woman.jpg')},
								{model: '华为 WATCH 2 Pro保时捷版',price:'2059.00',img:require('../assets/images/goods/huawei/WATCH_2_Pro.jpg')},
								{model: '华为 WATCH GT1雅致款',price:'1215.00',img:require('../assets/images/goods/huawei/WATCH_GT1.jpg')}
							]
						},
						{
							brand: '小米',
							list: [
								{model: '小米手表',price:'644.00',img:require('../assets/images/goods/xiaomi/XMWT01.jpg')},
								{model: '小米手环4',price:'96.00',img:require('../assets/images/goods/xiaomi/XMSH04.jpg')},
								{model: '小米手环5',price:'105.00',img:require('../assets/images/goods/xiaomi/XMSH05.jpg')},
								{model: '小米手表color运动智能手表',price:'287.00',img:require('../assets/images/goods/xiaomi/XMWT_Color.jpg')},
								{model: '小米米兔儿童电话手表4C',price:'115.00',img:require('../assets/images/goods/xiaomi/XMWTTU.jpg')}	
							]
						},
						{
							brand: '三星',
							list: [
								{model: '三星 Galaxy Watch3智能电话手表',price:'2289.00',img:require('../assets/images/goods/samsung/Galaxy_Watch3.jpg')},
								{model: '三星 Samsung Galaxy watch LTE版 智能手表 5ATM防水',price:'1459.00',img:require('../assets/images/goods/samsung/Galaxy_watch_LTE.jpg')},
								{model: '三星 Galaxy watch active2智能运动手表',price:'1387.00',img:require('../assets/images/goods/samsung/Galaxy_Watch_Active2.jpg')},
								{model: '三星 Galaxy Watch智能手表Gear S4 LTE蜂窝板',price:'648.00',img:require('../assets/images/goods/samsung/Galaxy_Watch_Gear_S4_LTE.jpg')},
								{model: '三星Galaxy Watch 智能手表男成人gear S4运动手表',price:'715.00',img:require('../assets/images/goods/samsung/Galaxy_Watch_gear_S4.jpg')}	
							]
						}
					]
				},
				{
					title: '耳机',
					icon: require('../assets/images/icon_headset.png'),
					brandList: [
						{
							brand: '苹果',
							list: [
								{model: '苹果 AirPods Pro 主动降噪无线蓝牙耳机',price:'889.00',img:require('../assets/images/goods/apple/AirPods_Pro.jpg')},
								{model: '苹果 AirPods',price:'562.00',img:require('../assets/images/goods/apple/AirPods_1.jpg')},
								{model: '苹果 EarPods 耳机',price:'89.00',img:require('../assets/images/goods/apple/EarPods.jpg')},
							]
						},
						{
							brand: '华为',
							list: [
								// {model: '华为 FreeBuds Pro',price:'789.00',img:require('../assets/images/goods/huawei/FreeBuds_Pro.jpg')},
								{model: '华为 FreeBuds3',price:'568.00',img:require('../assets/images/goods/huawei/FreeBuds3.jpg')},
								{model: '华为 FreeBuds 悦享版',price:'109.00',img:require('../assets/images/goods/huawei/FreeBuds1.jpg')},
								{model: '华为 FreeLace Pro 无线耳机',price:'562.00',img:require('../assets/images/goods/huawei/FreeLace_Pro.jpg')},
							]
						},
						{
							brand: '索尼',
							list: [
								{model: '索尼 WH-1000XM3',price:'1058.00',img:require('../assets/images/goods/sony/WH-1000XM3.jpg')},
								{model: '索尼 WI-1000XM2',price:'1254.00',img:require('../assets/images/goods/sony/WI-1000XM2.jpg')},
								{model: '索尼 WH-CH510',price:'109.00',img:require('../assets/images/goods/sony/WH-CH510.jpg')},
								{model: '索尼 WF-1000XM3',price:'687.00',img:require('../assets/images/goods/sony/WF-1000XM3.jpg')},
								{model: '索尼 WI-XB400',price:'687.00',img:require('../assets/images/goods/sony/WI-XB400.jpg')},
							]
						},
						{
							brand: 'Beats',
							list: [
								{model: 'Beats Studio3 Wireless苹果魔音耳机头戴式录音师3无线蓝牙降噪耳麦',price:'1689.00',img:require('../assets/images/goods/beats/Beats_Studio3_Wireless.jpg')},
								{model: 'Beats Solo3 Wireless头戴式蓝牙无线魔音耳机 苹果耳机运动游戏耳机耳麦 桀骜黑红',price:'687.00',img:require('../assets/images/goods/beats/Beats_Solo3_Wireless.jpg')},
								{model: 'Beats X 运动耳机魔音挂脖颈挂式苹果耳机无线蓝牙入耳式魔声耳机 带麦 黑色 通用版',price:'268.00',img:require('../assets/images/goods/beats/Beats_X.jpg')},
							]
						},
					]
				},
				{
					title: '音响',
					icon: require('../assets/images/icon_sound.png'),
					brandList: [
						{
							brand: '索尼',
							list: [
								{model: '索尼 HT-S350 蓝牙家庭影音系统',price:'758.00',img:require('../assets/images/goods/sony/HT-S350.jpg')},
								{model: '索尼 HT-X8500家庭影院 回音壁 杜比全景声 无线家庭音响 7.1.2声道音效 双重低音',price:'1044.00',img:require('../assets/images/goods/sony/HT-X8500.jpg')},
								{model: '索尼 HT-X9000F无线家庭音响系统 家庭影院 回音壁 电视音响 7.1声道杜比音效',price:'1420.00',img:require('../assets/images/goods/sony/HT-X9000F.jpg')},
								{model: '索尼 SA-Z9R 后置扬声器 音响 音箱',price:'887.00',img:require('../assets/images/goods/sony/SA-Z9R.jpg')},
								{model: '索尼 HT-MT300 迷你回音壁 音响 支持沙发模式 NFC无线蓝牙 电视音响 家庭影院 Minibar',price:'578.00',img:require('../assets/images/goods/sony/HT-MT300.jpg')},
							]
						},
						{
							brand: '漫步者',
							list: [
								{model: '漫步者 E3200多媒体电脑音箱通用低音炮2.1线控电视音响',price:'128.00',img:require('../assets/images/goods/edifier/E3200.jpg')},
								{model: '漫步者 R1700BT 蓝牙电视音箱',price:'225.00',img:require('../assets/images/goods/edifier/R1700BT.jpg')},
								{model: '漫步者 BIG BUN 蓝牙音箱',price:'118.00',img:require('../assets/images/goods/edifier/BIG_BUN.jpg')},
								{model: '漫步者 X2 2.1声道多媒体有源蓝牙音箱',price:'105.00',img:require('../assets/images/goods/edifier/X2.jpg')},
								{model: '漫步者 R303BT',price:'189.00',img:require('../assets/images/goods/edifier/R303BT.jpg')},
							]
						},
						{
							brand: 'Beats',
							list: [
								{model: 'Beats Pill+蓝牙音箱便携式无线苹果胶囊式迷你耳机音响二合一 红色',price:'789.00',img:require('../assets/images/goods/beats/Beats_Pill.jpg')},
							]
						},
						{
							brand: 'JBL',
							list: [
								{model: 'JBL PULSE3 音乐脉动三代',price:'687.00',img:require('../assets/images/goods/jbl/PULSE3.jpg')},
								{model: 'JBL FLIP ESSENTIAL 旗舰畅销款',price:'287.00',img:require('../assets/images/goods/jbl/FLIP_ESSENTIAL.jpg')},
								{model: 'JBL CHARGE4 音乐冲击波四代',price:'576.00',img:require('../assets/images/goods/jbl/CHARGE4.jpg')},
								{model: 'JBL CHARGE ESSENTIAL 音乐冲击波经典畅销款',price:'.00',img:require('../assets/images/goods/jbl/CHARGE_ESSENTIAL.jpg')},
								{model: 'JBL GO2 音乐金砖二代',price:'114.00',img:require('../assets/images/goods/jbl/GO2.jpg')},
							]
						},
						
					]
				},
				{
					title: '电子书',
					icon: require('../assets/images/icon_pad.png'),
					brandList: [
						{
							brand: 'Kindle',
							list: [
								{model: 'Kindle Paperwhite4墨水屏电子书阅读器',price:'438.00',img:require('../assets/images/goods/kindle/Kindle_Paperwhite4.jpg')},
								{model: 'Kindle青春版 墨水屏电子书阅读器',price:'254.00',img:require('../assets/images/goods/kindle/Kindle_Young.jpg')},
								{model: 'Kindle 青春版8G',price:'189.00',img:require('../assets/images/goods/kindle/Kindle_Enter.png')}
							]
						},
					]
				}
			],
			processList: [
				{title:'在线估价',image:require('../assets/images/icon_gujia.png')},
				{title:'顺丰包邮',image:require('../assets/images/icon_sf.png')},
				{title:'专业质检',image:require('../assets/images/icon_zhijian.png')},
				{title:'极速打款',image:require('../assets/images/icon_dakuan.png')}
			],
		}
	},
	
	methods:{
		mouseover(index){
			this.current = index
			this.brandCurrent = 0
		},
		
		mouseleave(){
			this.current = 99
		},
		
		brandover(index){
			this.brandCurrent = index
		},
		
		showMask(){
			this.$emit('showMask',true)
		}
	},
	
}
</script>

<style scoped>
.swiper{
	background-color: #fff;
	position: relative;
}

.menu-wrap{
	
}

.swiper-box{
	position: absolute;
	width: 1226px;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
}

.banner{
	width: 1226px;
	height: 400px;
}

.nav-box{
	position: relative;
	width: 1226px;
	height: 400px;
	margin: 0 auto;
}

.nav-box .m-menu{
	width: 1226px;
	height: 400px;
	position: absolute;
	top: 0;
	left: 0;
	display: flex;
}

.nav-box .m-menu dl{
	width: 234px;
	height: 400px;
	display: flex;
	flex-direction: column;
	background-color: rgba(71,71,71,.6);
}

.nav-box .m-menu dd{
	width: 234px;
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	color: #fff;
	padding: 0 20px 0 40px;
	box-sizing: border-box;
}

.nav-box .m-menu dd:first-child{
	margin-top: 10px;
}

.active{
	background-color: #ff6700;
}

.m-menu dd .left{
	display: flex;
	align-items: center;
}

.m-menu .meu-befor-icon{
	width: 24px;
	height: 24px;
	margin-right: 10px;
}

.m-menu .right{
	display: flex;
	align-items: center;
	justify-content: center;
}

.m-menu .right img{
	width: 16px;
	height: 16px;
}

.m-menu .menu-detail-wrap{
	display: none;
	flex: 1;
}

.m-menu .menu-detail{
	display: flex;
	height: 400px;
	background-color: #fff;
	box-shadow: 0 0 10px 0 rgba(71,71,71,.2);
}

.m-menu .menu-detail-wrap:hover,
.m-menu dl:hover+.menu-detail-wrap{
	display: block;
}

.menu-detail .second-menu{
	width: 90px;
	height: 400px;
	background-color: #f5f5f5;
	display: flex;
	flex-direction: column;
}

.menu-detail .second-menu li{
	width: 100%;
	height: 60px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}

.brand-active{
	background-color: #fff !important;
	color: #ff6700 !important;
}

.menu-detail .goods-menu{
	flex: 1;
	padding: 30px;
	box-sizing: border-box;
	display: flex;
	flex-wrap: wrap;
	align-content: flex-start;
	justify-content: space-between;
}

.menu-detail .goods-item{
	width: 230px;
	height: 66px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 10px;
	padding-right: 16px;
}

.menu-detail .goods-item .left{
	display: flex;
	align-items: center;
}

.menu-detail .goods-item img{
	width: 42px;
	height: 42px;
}

.menu-detail .goods-item span{
	margin-left: 10px;
	width: 120px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	margin-left: 16px;
}

.menu-detail .goods-item .right{
	width: 50px;
	height: 20px;
	line-height: 20px;
	border: 1px solid #ff6700;
	font-size: 14px;
	color: #ff6700;
	text-align: center;
	cursor: pointer;
	transition: all 0.3s;
}

.menu-detail .goods-item .right:hover{
	background-color: #ff6700;
	color: #fff;
}

.goods-item .more{
	width: 100px;
	height: 26px;
	line-height: 26px;
	border: 1px solid #ff6700;
	text-align: center;
	font-size: 14px;
	margin-left: 30px;
	color: #ff6700;
	cursor: pointer;
}

.m-process-box{
	width: 1226px;
	margin: 0 auto;
	padding: 20px 0;
	background-color: #fff;
}

.m-process-box .process-box-title{
	font-size: 24px;
	color: #282828;
}

.m-process-box .process-box-title .border{
	width: 45px;
	height: 4px;
	background-color: #ff6700;
}

.m-process-box .process-list{
	display: flex;
	margin-top: 40px;
}

.m-process-box .process-list .process-item{
	width: 373px;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.m-process-box .process-list .process-item:last-child{
	width: 106px !important;
}

.item-line{
	flex: 1;
	transform: translateY(-10px);
}

.m-process-box .process-item .process-icon{
	width: 100px;
	height: 100px;
}

.m-process-box .process-item .process-title{
	margin-top: 16px;
}
</style>
